/* Utils */
import { generateRandomStringId } from './functions';

function saveDeviceId() {
  const deviceIdSave = generateRandomStringId();
  localStorage.setItem('deviceId', deviceIdSave);
  return deviceIdSave;
}

let deviceId;

export function getDeviceId() {
  deviceId = deviceId || localStorage.getItem('deviceId');

  if (!deviceId) {
    deviceId = saveDeviceId();
  }

  return deviceId;
}
